export default {
  state: {
    cardData: {},
    cardType: null,
    productSelectedDiscount: {},
    productSelectedCurrency: {},
    productSelectedTrackingCode: {}
  },

  getters: {
    getCardData (state) {
      return state.cardData
    },

    getCardType (state) {
      return state.cardType
    },

    getProductSelectedDiscount (state) {
      return state.productSelectedDiscount
    },

    getProductSelectedCurrency (state) {
      return state.productSelectedCurrency
    },

    getProductSelectedTrackingCode (state) {
      return state.productSelectedTrackingCode
    }
  },

  mutations: {
    setCardData (state, cardData) {
      state.cardData = cardData
    },

    setCardType (state, cardType) {
      state.cardType = cardType
    },

    setProductSelectedDiscount (state, productSelectedDiscount) {
      state.productSelectedDiscount = productSelectedDiscount
    },

    setProductSelectedCurrency (state, productSelectedCurrency) {
      state.productSelectedCurrency = productSelectedCurrency
    },

    setProductSelectedTrackingCode (state, productSelectedTrackingCode) {
      state.productSelectedTrackingCode = productSelectedTrackingCode
    },

    unsetCardData (state) {
      state.cardData = null
    },

    unsetCardType (state) {
      state.cardType = null
    },

    unsetProductSelectedDiscount (state) {
      state.productSelectedDiscount = null
    },

    unsetProductSelectedCurrency (state) {
      state.productSelectedCurrency = null
    },

    unsetProductSelectedTrackingCode (state) {
      state.productSelectedTrackingCode = null
    }
  }
}
